// pages/Login/index.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { authService } from "../../services/auth.service";
import { Button } from "../../styles/components";
import {
	LoginWrapper,
	LoginCard,
	Logo,
	Form,
	FormGroup,
	Label,
	Input,
	ErrorMessage,
	ForgotPassword,
	RegisterLink,
} from "./styles";

const Login = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			const { userData } = await authService.login(
				formData.email,
				formData.password
			);
			toast.success("Login successful!", {
				style: {
					padding: "1rem",
				},
			});

			// Redirect based on user role
			if (userData?.role === "admin") {
				navigate("/admin");
			} else {
				navigate("/dashboard");
			}
		} catch (err) {
			setError("Invalid email or password");
			toast.error("Login failed. Please try again.", {
				style: { padding: "1rem" },
			});
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (e) => {
		setFormData((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};

	return (
		<LoginWrapper>
			<LoginCard
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6 }}
			>
				<Logo>
					<h1>Le Petit</h1>
				</Logo>

				<Form onSubmit={handleSubmit}>
					<FormGroup>
						<Label htmlFor="email">Email</Label>
						<Input
							type="email"
							id="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							required
							autoComplete="email"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="password">Password</Label>
						<Input
							type="password"
							id="password"
							name="password"
							value={formData.password}
							onChange={handleChange}
							required
							autoComplete="current-password"
						/>
					</FormGroup>

					{error && <ErrorMessage>{error}</ErrorMessage>}

					<ForgotPassword to="/forgot-password">
						Forgot your password?
					</ForgotPassword>

					<Button type="submit" disabled={loading} size="large">
						{loading ? "Signing in..." : "Sign In"}
					</Button>
				</Form>

				<RegisterLink>
					Don't have an account? <Link to="/register">Sign up</Link>
				</RegisterLink>
			</LoginCard>
		</LoginWrapper>
	);
};

export default Login;
